import { Pipe, PipeTransform } from '@angular/core';

import { DatePipe } from '@angular/common';

@Pipe({
  name: 'stringInjection'
})
export class OpenStringInjectionPipe implements PipeTransform {

  constructor(
    private datePipe: DatePipe
  ) {}
  transform(value: string, results: any): unknown {
    // below regex matches {{key|<pipe>}} or {{ key | <pipe> }} via optional white space
    // it also grabs just the `key` via a group accessed as the 2nd element [1]
    // it also grabs just the `pipe` via a group accessed as the 3rd element [2]
    // key is then looked for in `results`, otherwise the key string itself is returned.
    // pipe is then used for any further transformation, such as for dates.
    const templateLiterals = value.matchAll(/{{\s*([^\s|]+)\s*\|*\s*(\S*)\s*}}/g);
    let transformedValue = value;
    if (templateLiterals) {
      for (const templateLiteral of templateLiterals) {
        const matchedString = templateLiteral[0] // {{ key | pipe }}
        const matchedKey = templateLiteral[1] // key
        const matchedPipe = templateLiteral[2] // pipe
        let pipedOutput = null;

        switch (matchedPipe) {
          case 'date':
            pipedOutput = this.datePipe.transform(results[matchedKey], "dd MMM yyyy")
            break;
          default:
            break;
        }
        
        transformedValue = transformedValue.replace(matchedString, pipedOutput || results[matchedKey] || matchedKey);  
      }
    }
    
    return transformedValue;
  }
}